import React, { ReactElement } from 'react';
import './App.css';
import IncubatorInvestmentDashboard from './pages/HomeDashBoard';

function App(): ReactElement {
  return <IncubatorInvestmentDashboard />;
}

export default App;
